/**
 * An event's page (`/events/:eventId/:nameSlug?`, web-client-app D11, task 8.7):
 * the event page piece with the photo gallery and the booking column in it.
 * An event the studio does not list shows the studio's not-found page.
 */
import { BookingColumn } from '../pieces/booking-column';
import { EventPageView, useEventPage } from '../pieces/event-page';
import { MessageStudio } from '../pieces/message-studio';
import { PhotoGallery } from '../pieces/photo-gallery';
import { PhoneEventPage } from '../phone/PhoneEventPage';
import { readSite } from '../site';
import { useAppScreens } from '../ui/useIsPhone';
import { usePageTitle } from '../ui/usePageTitle';
import { NotFoundPage } from './NotFoundPage';

export function EventPage() {
  const page = useEventPage();
  const phone = useAppScreens();
  usePageTitle(page.state.event?.title);
  if (page.state.status === 'not-found') return <NotFoundPage />;
  // Below 768px the page is the Mini App's event page (Gabriel 2026-10-21).
  if (phone) return <PhoneEventPage event={page.state.event} />;
  // web-studio-sites D15: Message the studio under the details when her site turns it on.
  const message = readSite()?.telifyPages.messageStudio ? <MessageStudio about="event" /> : undefined;
  return <EventPageView {...page} photos={<PhotoGallery />} booking={<BookingColumn />} message={message} />;
}
